import { TId } from '@apia/util';
import { createContext, useContext } from 'react';
import { TAccordionHandler } from '.';

export const AccordionContext = createContext<TAccordionHandler | null>(null);
export const AccordionItemContext = createContext<TId | null>(null);

export const useAccordionContext = () => {
  const context = useContext(AccordionContext);
  if (!context) throw new Error('There is no AccordionContext');
  return context;
};
